{
    "Profile_Renewal_Header.renewalReview": "Renewal Review",
    "Profile_Renewal_Header.createRenewal": "Create a Renewal",
    "Profile_Renewal_Header.bound": "Bound",
    "Profile_Renewal_Header.youreAllSet": "You're all set!",
    "Profile_Renewal_Header.renewalPolicy": "Renewal Policy",
    "Profile_Renewal_Header.welcome": "Welcome",
    "Profile_Renewal_Header.subHeader": "Here is your policy renewal information"
}
